import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "enforce-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.7 10.92A9.75 9.75 0 1 0 12 21.76a.75.75 0 0 0 0-1.5 8.25 8.25 0 1 1 8.2-9.18.75.75 0 0 0 1.5-.16Z" }, null, -1),
    _createElementVNode("path", { d: "M15.03 10.19c.3.29.3.76 0 1.06l-3.12 3.12c-.3.3-.77.3-1.06 0L8.97 12.5a.75.75 0 0 1 1.06-1.06l1.35 1.34 2.6-2.6c.29-.29.76-.29 1.05 0Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 13.25a2.5 2.5 0 0 0-2.5 2.5v.65a2 2 0 0 0-1.24 1.85v2.5c0 1.11.9 2 2 2h3.5a2 2 0 0 0 2-2v-2.5a2 2 0 0 0-1.25-1.85v-.65a2.5 2.5 0 0 0-2.5-2.5Zm1 3v-.5a1 1 0 0 0-2 0v.5h2Zm-3.24 2c0-.27.22-.5.5-.5h3.5c.27 0 .5.23.5.5v2.5a.5.5 0 0 1-.5.5h-3.5a.5.5 0 0 1-.5-.5v-2.5Z"
    }, null, -1)
  ])))
}
export default { render: render }